export const RS_TURBO_2 = {
  titleTable: "LOTO TURBO",
  descriptionTable: "DRAW [number] NUMBERS + [bonus] BONUS",
  descriptionKeyNumber: "5",
  descriptionKeyBonus: "2",
  colspan: "2",
  dataTableHeader: [
    { title: "TURBO [number]", key: "2" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "2,400",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "40",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "40",
    },
  ],
};

export const RS_TURBO_3 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "TURBO [number]", key: "3" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "800",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "30",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "30",
    },
  ],
};

export const RS_TURBO_4 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "TURBO [number]", key: "4" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "400",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "25",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "25",
    },
  ],
};

export const RS_TURBO_5 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "TURBO [number]", key: "5" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "300",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "12",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "12",
    },
  ],
};
